module.exports = __webpack_public_path__ + "img/logo-club.e2c908f8.png";